/**
 * A class representing the financial info
 */
export class FinancialInfo {
    /**
     * Create a FinancialInfo object
     * @param {boolean} areAccountSplitByMaterial
     * @param {AccountDetailsByMaterial[]} accountDetailsByMaterial
     * @param {Account[]} accounts
     */
    constructor(
        areAccountSplitByMaterial,
        accountDetailsByMaterial,
        accounts,
    ) {
        this._areAccountSplitByMaterial = areAccountSplitByMaterial;
        this._accounts = accounts;
        this._accountDetailsByMaterial = accountDetailsByMaterial;
    }

    /**
     * Get an JS object containing all the information about the material.
     * @return {{}}
     */
    getFinancialInfo() {
        return {
            areAccountSplitByMaterial: this._areAccountSplitByMaterial,
            accounts: this._areAccountSplitByMaterial ? [] : this._accounts.map((account) => account.getAccount()),
            accountDetailsByMaterial: this._areAccountSplitByMaterial ? this._accountDetailsByMaterial.map((a) => a.getAccountDetailsByMaterial()) : [],
        };
    }

    /**
     * Get the areAccountSplitByMaterial value.
     * @return {boolean} The areAccountSplitByMaterial value.
     */
    get areAccountSplitByMaterial() {
        return this._areAccountSplitByMaterial;
    }

    /**
     * Set the areAccountSplitByMaterial value.
     * @param {boolean} value to set
     */
    set areAccountSplitByMaterial(value) {
        this._areAccountSplitByMaterial = value;
    }

    /**
     * Get the accountDetailsByMaterial value.
     * @return {AccountDetailsByMaterial[]} The accountDetailsByMaterial value.
     */
    get accountDetailsByMaterial() {
        return this._accountDetailsByMaterial;
    }

    /**
     * Set the accountDetailsByMaterial value.
     * @param {AccountDetailsByMaterial[]} value to set
     */
    set accountDetailsByMaterial(value) {
        this._accountDetailsByMaterial = value;
    }

    /**
     * Get the accounts value.
     * @return {Account[]} The accounts value.
     */
    get accounts() {
        return this._accounts;
    }

    /**
     * Set the accounts value.
     * @param {Account[]} value to set
     */
    set accounts(value) {
        this._accounts = value;
    }
}
